const UsersModule = {
    namespaced: true,
    state: {
        refreshKey: null,
        refreshKeyProfileList: null,
        selectedUserRowId: null,
        selectedUserId: null,
    },
    actions: {
        REFRESH({ state, commit }, refreshKey) {
            commit('SetRefreshUserList', refreshKey);
        },
        REFRESHASSOCIATED({ state, commit }, refreshKeyProfileList) {
            commit('SetRefreshUserProfileList', refreshKeyProfileList);
        },
        SELECT_USER_ROW_ID({ state, commit }, selectedUserRowId) {
            commit('SetUserRowId', selectedUserRowId);
        },
        SELECT_USER_ID({ state, commit }, selectedUserId) {
            commit('SetUserId', selectedUserId);
        },
    },
    mutations: {
        SetRefreshUserList: function (state, refreshKey) {
            state.refreshKey = refreshKey;
        },
        SetRefreshUserProfileList: function (state, refreshKeyProfileList) {
            state.refreshKeyProfileList = refreshKeyProfileList;
        },
        SetUserRowId: function (state, selectedUserRowId) {
            state.selectedUserRowId = selectedUserRowId;
        },
        SetUserId: function (state, selectedUserId) {
            state.selectedUserId = selectedUserId;
        }
    },
    getters: {
        GetRefreshUserList: function (state) {
            try {
                return state.refreshKey;
            } catch (err) {
                return null;
            }
        },
        GetRefreshUserProfileList: function (state) {
            try {
                return state.refreshKeyProfileList;
            } catch (err) {
                return null;
            }
        },
        GetSelectedUserRowId: function (state) {
            return state.selectedUserRowId
        },
        GetSelectedUserId: function (state) {
            return state.selectedUserId
        }
    },
};
export default UsersModule;